import * as actions from './redux/actions';
import * as commonActions from '../common/redux/actions';
import * as myAccountActions from '../my-account/redux/actions';
import * as serviceActions from '../Pasajebus/PasajebusServiceList/redux/actions';

import React, { Component } from 'react';

import ApiUrls from '../../services/apiUrls';
import CareSection from './CareSection/CareSection';
import CommonService from '../../services/commonService';
import DateService from '../../services/dateService';
import Destinations from './Destinations/Destinations';
import DownloadAndSupport from './DownloadAndSupport/DownloadAndSupport';
import HomeBanner from './HomeBanner/HomeBanner';
import HomeSearchBoxPB from './HomeSearchBoxPB/HomeSearchBoxPB';
import { HomeSection1 } from './HomeSection1/HomeSection1';
import { KuposErrorSuccessModal } from '../common';
import { PopupMessage } from '../common/PopupMessage';
import PropTypes from 'prop-types';
import SubBanner from './Banner/SubBanner';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import i18next from 'i18next';
import { withTranslation } from 'react-i18next';

const careItems = [
  {
    icon: '/images/pullman/home/covid-Icon1.svg',
    heading: 'HOME.SANITIZED_BUSES',
    body: 'HOME.SANITIZED_BUSES_BODY',
  },
  {
    icon: '/images/pullman/home/covid-Icon2.svg',
    heading: 'HOME.DOCUMENTS_CONTROL',
    body: 'HOME.DOCUMENTS_CONTROL_BODY',
  },
  {
    icon: '/images/pullman/home/covid-Icon3.svg',
    heading: 'HOME.VIRTUAL_TICKET',
    body: 'HOME.VIRTUAL_TICKET_BODY',
  },
];
const destinationItemsEs = [
  {
    icon: '/images/pullman/home/destinations-es-1.png',
  },
  {
    icon: '/images/pullman/home/destinations-es-2.png',
  },
  {
    icon: '/images/pullman/home/destinations-es-3.png',
  },
  {
    icon: '/images/pullman/home/destinations-es-4.png',
  },
  {
    icon: '/images/pullman/home/destinations-es-5.png',
  },
];

const destinationItemsEn = [
  {
    icon: '/images/pullman/home/destinations-en-1.png',
  },
  {
    icon: '/images/pullman/home/destinations-en-2.png',
  },
  {
    icon: '/images/pullman/home/destinations-en-3.png',
  },
  {
    icon: '/images/pullman/home/destinations-en-4.png',
  },
  {
    icon: '/images/pullman/home/destinations-en-5.png',
  },
];

export class DefaultPage extends Component {
  static propTypes = {
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    history: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.props.actions.setOnwardPbDate(DateService.getTodayString());
    CommonService.removeLocal('home');
    CommonService.removeLocal('pbServiceList');
    this.props.actions.setServiceOnward({
      coachLayoutJson: null,
      originStageDetails: null,
      destinationStageDetails: null,
      boardingStage: null,
      droppingStage: null,
      route: null,
    });
    this.props.actions.setServiceReturn({
      coachLayoutJson: null,
      originStageDetails: null,
      destinationStageDetails: null,
      boardingStage: null,
      droppingStage: null,
      route: null,
    });
    this.props.actions.selectSeatOnward({
      totalBookingAmount: 0,
      netBookingAmount: 0,
      discountAmount: 0,
      selectedSeatsToBook: null,
      selectedSeatsNumbers: null,
      selectedSeatTypes: null,
    });
    this.props.actions.selectSeatReturn({
      totalBookingAmount: 0,
      netBookingAmount: 0,
      discountAmount: 0,
      selectedSeatsToBook: null,
      selectedSeatsNumbers: null,
      selectedSeatTypes: null,
    });
    this.state = {
      bipEmail: null,
      KupoGoSelected: false,
      kuposGoSearchBody: false,
      subBannersEn: [],
      subBannersEs: [],
    };
  }

  onGetATSeatDetails = res => {
    if (res && res.data && res.data.success && res.data.data) {
      this.props.actions.setAtMastersData(res.data.data);
    }
  };

  // subBannersEs = [];
  // subBannersEn = [];

  componentDidMount() {
    CommonService.clearSearchFunction = this.searchBox ? this.searchBox.clearSelectValues : null;

    //RESET RETURN DATE FOR AT IF PRESENT
    if (this.props.home.transferData.selectedKupos) {
      this.props.actions.setTransferData({ selectedEndDate: null });
      this.props.actions.setTransferData({ selectedEndTime: null });
      this.props.actions.setTransferData({
        selectedKupos: 1,
      });

      this.props.actions.setTransferData({
        selectedAdultKupos: 1,
      });

      this.props.actions.setTransferData({
        selectedKidKupos: 0,
      });

      this.props.actions.setTransferData({
        selectedInfantKupos: 0,
      });

      this.props.actions.setTransferData({ selectedStartDate: DateService.getTodayString() });
      this.props.actions.setTransferData({ selectedStartTime: '00:00' });
    }

    setTimeout(() => {
      if (this.props.common.loginData) {
        this.props.actions.getProfile({ url: ApiUrls.profile() }).then(
          res => {
            if (res && res.error) {
              return;
            } else if (res && res.auth_token) {
              CommonService.storeLoginDetails(res, this.props.actions.setLoginData);
            }
          },
          err => {
            if (err && err.status == 401) {
              try {
                let googleAccessToken = localStorage.getItem('googleAccessToken');
                if (googleAccessToken)
                  this.props.actions.googleLogout({
                    url: ApiUrls.googleLogout(googleAccessToken),
                  });
                window.FB.logout();
              } catch (e) {
                console.log(e);
              }
              CommonService.storeLoginDetails(null, this.props.actions.setLoginData);
              CommonService.logout();
            }
          },
        );
      }
    }, 200);
    if (this.props.history.location) {
      if (
        this.props.history.location.pathname.indexOf('pasajes-bus') > -1 ||
        this.props.history.location.pathname.indexOf('bus-tickets') > -1
      ) {
        this.props.actions.setSearchApp(0);
      }
    }

    // if (this.props.home.metaData && this.props.home.metaData.pullman_banners['sub-images']) {
    //   this.props.home.metaData.pullman_banners['sub-images'].en.forEach(item => {
    //     console.log('subBannersEn', this.state.subBannersEn);
    //     console.log('subBannersEn', item);
    //     this.setState({
    //       subBannersEn: [...this.state.subBannersEn, item],
    //     });
    //   });
    //   this.props.home.metaData.pullman_banners['sub-images'].es.forEach(item => {
    //     this.setState({
    //       subBannersEs: [...this.state.subBannersEs, item],
    //     });
    //   });
    // }
  }

  // componentWillUnmount() {
  //   this.props.actions.pbSetSourceCity(null);
  //   this.props.actions.pbSetDestinationCity(null);
  //   this.props.actions.setOnwardPbDate(null);
  // }

  onwardDateChange = date => {
    this.props.actions.setOnwardPbDate(date);

    //remove the return date when onward date is selected
    if (this.props.home.returnPBDate && date > this.props.home.returnPBDate)
      this.props.actions.setReturnPbDate(date);
    // this.props.home.returnPBDate ? this.props.actions.setReturnPbDate(date) : null;
  };

  returnDateChange = date => {
    this.props.actions.setReturnPbDate(date);
  };

  sourceCityOnChange = value => {
    this.props.actions.pbSetSourceCity(value);
  };

  destinationCityOnChange = value => {
    this.props.actions.pbSetDestinationCity(value);
  };

  searchPB = () => {
    sessionStorage.removeItem('confirmTicketData');
    sessionStorage.removeItem('changeTicketDetailsResponse');
    sessionStorage.removeItem('confirmTicketDataResponse');
    let source = this.props.home.pbSourceCity.label
      .toLowerCase()
      .replace(/-/g, '_')
      .replace(/ /g, '-')
      .replace(/_/g, '--');
    let dest = this.props.home.pbDestinationCity.label
      .toLowerCase()
      .replace(/-/g, '_')
      .replace(/ /g, '-')
      .replace(/_/g, '--');
    this.props.actions.setServiceListOnward(null);
    if (!this.props.home.returnPBDate) {
      this.props.history.push(
        `/${i18next.language}/${
          i18next.language == 'es' ? 'pasajes-bus' : 'bus-tickets'
        }/${source}/${dest}/${this.props.home.onwardPBDate}`,
      );
    } else {
      this.props.history.push(
        `/${i18next.language}/${
          i18next.language == 'es' ? 'pasajes-bus' : 'bus-tickets'
        }/${source}/${dest}/${this.props.home.onwardPBDate}/${this.props.home.returnPBDate}/1`,
      );
    }
  };

  // sourceInputChange = val => {};

  // destinationInputChange = val => {};

  onCancelPrintTabChange = key => {
    this.setState({
      capsuleMenuAcktiveTab: this.state.capsuleMenuAcktiveTab == key ? null : key,
    });
  };

  onCancelPrintTicketSubmit = (path, pnr) => {
    this.setState({
      ticketDetails: null,
    });

    this.props.actions.loadTicketDetails({ url: ApiUrls.ticketDetails(pnr, path) }).then(res => {
      // this.props.actions.setTicketDetails(res);
      if (res.body && res.body.pnr_number) {
        if (this.state.capsuleMenuAcktiveTab == 0) {
          window.open(res.body.print_pdf_url, '_blank');
        } else {
          this.props.history.push('/modify-ticket/cancel');
        }
      } else {
        sessionStorage.removeItem('ticketInfo');
        this.setState({ showModal: true, modalBodyText: res.body.message });
      }
    });
  };

  setSearchApp = key => {
    switch (key) {
      case 0:
        this.props.history.push(
          `/${i18next.language}/${i18next.language === 'en' ? 'bus-tickets' : 'pasajes-bus'}`,
        );
        break;
      default:
        this.props.history.push(
          `/${i18next.language}/${i18next.language === 'en' ? 'bus-tickets' : 'pasajes-bus'}`,
        );
        break;
    }
    this.props.actions.setSearchApp(key);
  };

  // subBanner = () => {
  //   if (this.props.home.metaData.pullman_banners.banners) {
  //   }
  // };

  render() {
    const { t, history } = this.props;
    return (
      <div className="home-default-page">
        {/* {this.props.home.metaData &&
        this.props.home.metaData.kupos_popup_details &&
        this.props.home.metaData.kupos_popup_details[0] &&
        this.props.home.metaData.kupos_popup_details[0].status &&
        this.props.home.metaData.kupos_popup_details[0].popup_type == 1 ? (
          <div className="flash-message-container">
            <img
              src={this.props.home.metaData.kupos_popup_details[0].image_url}
              alt="flash-message"
            />
          </div>
        ) : null} */}

        <div className="banner-and-searchbox">
          <div className="home-banner-container">
            <HomeBanner
              pullmanBanners={
                this.props.home.metaData &&
                this.props.home.metaData.pullman_banners &&
                this.props.home.metaData.pullman_banners.banners
              }
            />
          </div>

          <div
            // style={{ position: 'relative', top: '-140px', color: '#fff' }}
            className={
              'home-search-box-container search-box-over-banner ' +
              (this.props.home.selectedSearchApp == 5 ? 'kupos-go-selected' : '')
            }
          >
            <HomeSearchBoxPB
              ref={instance => {
                this.searchBox = instance;
              }}
              history={this.props.history}
              actions={this.props.actions}
              onwardDate={this.props.home.onwardPBDate}
              onwardDateChange={this.onwardDateChange}
              returnDate={this.props.home.returnPBDate}
              returnDateChange={this.returnDateChange}
              selectSourceCity={this.props.home.pbSourceCity}
              sourceCityOptions={this.props.home.uniqueCities}
              sourceCityOnChange={this.sourceCityOnChange}
              onSourceInputChange={this.sourceInputChange}
              sourcePlaceholder="Origen"
              selectDestinationCity={this.props.home.pbDestinationCity}
              destinationCityOptions={this.props.home.uniqueCities}
              destinationCityOnChange={this.destinationCityOnChange}
              onDestinationInputChange={this.destinationInputChange}
              destinationPlaceholder="Destino"
              onSearch={this.searchPB}
              t={t}
              onCancelPrintTicketSubmit={this.onCancelPrintTicketSubmit}
              onCancelPrintTabChange={this.onCancelPrintTabChange}
              metaData={this.props.home.metaData}
              loginData={this.props.common.loginData}
              setSearchApp={this.setSearchApp}
              selectedSearchApp={this.props.home.selectedSearchApp}
              loadTicketDetails={this.props.actions.loadTicketDetails}
              apiCall={this.props.actions.apiCall}
              is_mot={this.props.home.is_mot}
              common={this.props.common}
            />
          </div>
        </div>

        <div className="content-container">
          {/* <div className="banners-container">
            <SubBanner
              subBanners={
                this.props.home.metaData &&
                this.props.home.metaData.pullman_banners &&
                this.props.home.metaData.pullman_banners['sub-images']
              }
              imageLink1={() => window.open('https://www.pullmanmas.cl/')}
              imageNumber={1}
            />
          </div> */}

          {/* <HomeSection1
            t={this.props.t}
            img1={'/images/pullman/home/dog.png'}
            img2={'/images/pullman/home/MAB-Cat.png'}
          /> */}

          {/* <CareSection
            t={this.props.t}
            items={careItems}
            sectionTitle={t('HOME.WE_ALL_TAKE_CARE_OF_EACH_OTHER')}
          /> */}
        </div>

        <Destinations
          items={i18next.language === 'es' ? destinationItemsEs : destinationItemsEn}
          sectionTitle={t('HOME.TRAVELLING_THROUGH_CHILE')}
          sectionIntro={t('HOME.TRAVELLING_THROUGH_CHILE_BODY')}
          t={this.props.t}
          history={history}
        />

        <DownloadAndSupport t={this.props.t} props={this.props} />

        <div className="primary-background">
          <div className="print-cancel-container-home">
            <KuposErrorSuccessModal
              showModal={this.state.showModal}
              onButtonClick={() =>
                this.setState({
                  showModal: false,
                  modalTitle: '',
                  modalSubTitle: '',
                  modalBodyText: '',
                  modalTypeSuccess: false,
                })
              }
              title={this.state.modalTitle}
              subTitle={this.state.modalSubTitle}
              bodyText={this.state.modalBodyText}
              success={this.state.modalTypeSuccess}
            />
          </div>
        </div>

        {/* {this.props.home.metaData &&
        this.props.home.metaData.kupos_popup_details &&
        this.props.home.metaData.kupos_popup_details[0] &&
        this.props.home.metaData.kupos_popup_details[0].status &&
        this.props.home.metaData.kupos_popup_details[0].popup_type == 2 ? (
          <PopupMessage
            showModal={
              this.props.home.metaData.kupos_popup_details[0].status
              // this.props.home.metaData.kupos_popup_details[0].popup_type === 1 ? true : false
            }
            onHide={() => {
              let metaData = CommonService.copyObject(this.props.home.metaData);
              metaData.kupos_popup_details[0].status = 0;
              this.props.actions.setMetaData(metaData);
            }}
            metaData={this.props.home.metaData}
            t={this.props.t}
          />
        ) : null} */}
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...actions, ...serviceActions, ...myAccountActions, ...commonActions },
      dispatch,
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(DefaultPage));



// WEBPACK FOOTER //
// ./src/features/home/DefaultPage.js